import { isValidElement } from "react";
import { Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "./ui.css";

const DANGER = /delete|reject|disable/i;

// An action is { title, item, fn, disabled } exactly as ActionButtons.jsx builds
// it. `item` is either an icon (the click runs `fn`) or a react-router <Link>
// wrapping an icon (the click navigates, and still runs `fn` if one is set).
const isLink = (item) => isValidElement(item) && item.type === Link;

function InlineAction({ action }) {
  const { title, item, fn, disabled } = action;
  const className = `simcc-row-action${DANGER.test(title) ? " simcc-row-action--danger" : ""}`;
  const body = isLink(item) ? (
    <Link
      className={className}
      to={item.props.to}
      target={item.props.target}
      aria-label={title}
      onClick={() => fn && fn()}
    >
      {item.props.children}
    </Link>
  ) : (
    <button
      type="button"
      className={className}
      aria-label={title}
      disabled={disabled}
      onClick={() => fn && fn()}
    >
      {item}
    </button>
  );
  return (
    <Tooltip title={title} placement="top" disableInteractive>
      <span>{body}</span>
    </Tooltip>
  );
}

// Every available action for the row, side by side, in the order
// ActionButtons builds them.
export default function RowActions({ actions }) {
  const visible = actions.filter(Boolean);
  if (!visible.length) return null;
  return (
    <div className="simcc-row-actions">
      {visible.map((a, i) => (
        <InlineAction key={`${a.title}-${i}`} action={a} />
      ))}
    </div>
  );
}

const actionShape = PropTypes.shape({
  title: PropTypes.string.isRequired,
  item: PropTypes.node,
  fn: PropTypes.func,
  disabled: PropTypes.bool,
});

InlineAction.propTypes = { action: actionShape.isRequired };

RowActions.propTypes = {
  // falsy entries are allowed: ActionButtons gates actions with `cond && {...}`
  actions: PropTypes.arrayOf(PropTypes.oneOfType([actionShape, PropTypes.bool])).isRequired,
};
